<template>
  <section class="enterprise-cta">
    <div class="enterprise-shell enterprise-cta__inner">
      <h2>{{ t(isVipSite ? 'enterprise_home_cta_title_cn' : 'enterprise_home_cta_title_global') }}</h2>
      <p>{{ t('enterprise_home_cta_description') }}</p>
      <div>
        <NuxtLink :to="localePath('/account?menu=home')" class="enterprise-button enterprise-button--white">{{ t('enterprise_home_action_use') }}</NuxtLink>
        <button type="button" class="enterprise-button enterprise-button--ghost" @click="openSupport">{{ t('enterprise_home_cta_contact_sales') }}</button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useSiteConfig } from '~/config/useSiteConfig'

const localePath = useLocalePath()
const { t } = useI18n()
const { isVipSite } = useSiteConfig()

function openSupport() {
  window.$crisp?.do?.('chat:open')
}
</script>
